
import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import logo from '../tempo-logo.png'
import explicit from './explicit-content.png'
import GoPremium from '../../../../components/go-premium/GoPremium'
import Button from '../../../../components/Button'
import './Restrictions.css'

class Restrictions extends Component {

    constructor(props) {
        super(props)
        this.state = {
            open: false    
        }
    }
    
    goPremium = () => {
        this.setState({open: true})
    }

    handleClose = () => {
        this.setState({open: false})
    }

    render() {
        return (
            <section>
                <h1>Premium</h1>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="tempo-logo-container restriction" onClick={this.goPremium}>
                            <div className="tempo-logo">
                                <img src={logo} alt="Logo" className="tempo-img" /><span className="tempo-text">tempo</span>
                            </div>
                        </div>
                        <div className="restriction-detail" onClick={this.goPremium}>
                            Logo personalizado
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <div className="restriction" onClick={this.goPremium}>
                            <input type="text" value="XYT1" readOnly={true}></input>
                        </div>
                        <div className="restriction-detail" onClick={this.goPremium}>
                            Código personalizado para votar
                        </div>
                    </div>
                </div>
                <h1>Premium</h1>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <div className="restriction explicit" onClick={this.goPremium} title="Contenido explicito: ACTIVADO">
                            <FontAwesome
                                name='universal-access'
                            />
                        </div>
                        <div className="restriction-detail">
                            Activar contenido apto para toda la familia
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-6" onClick={this.goPremium}>
                        <div className="restriction">
                            <Button>
                                Daddy Yankee
                            </Button>
                            <Button>
                                Maluma
                            </Button>
                            <Button>
                                Bruno Mars
                            </Button>
                            <Button>
                                Adele
                            </Button>
                        </div>
                        <div className="restriction-detail">
                            Restringir artistas
                        </div>
                    </div>
                </div>
                <GoPremium open={this.state.open} onRequestClose={this.handleClose}/>   
            </section>
        )
    }
}

export default Restrictions;


// WEBPACK FOOTER //
// ./src/pages/home/sections/restrictions/Restrictions.js